import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=5311f43c"
import script from "./ActionButton.vue?vue&type=script&lang=ts"
export * from "./ActionButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports